module.exports = __webpack_public_path__ + "static/img/shop-activity.3855f297.png";